module.exports = __webpack_public_path__ + "media/src/images/viewbtn/normal-off-af0a538140033c62e0ef9db53ec1dbf5.png";